export const ROLE_META = {
  super_admin: { label: 'Super Admin', icon: 'fa-shield-halved' },
  admin: { label: 'Admin', icon: 'fa-shield-halved' },
  staff: { label: 'Programme Executive', icon: 'fa-calendar-pen' },
  trainer: { label: 'Lecturer', icon: 'fa-chalkboard-user' },
  student: { label: 'Student', icon: 'fa-user-graduate' },
};

export function getRoleMeta(role) {
  return ROLE_META[role] || { label: role || 'User', icon: 'fa-user' };
}
